var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactmessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.608,
    height: 25.6,
    viewBox: "0 0 33.608 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M30.654,61H2.954A2.959,2.959,0,0,0,0,63.954V83.646A2.959,2.959,0,0,0,2.954,86.6h27.7a2.959,2.959,0,0,0,2.954-2.954V63.954A2.959,2.959,0,0,0,30.654,61Zm-.408,1.969-13.38,13.38-13.5-13.38ZM1.969,83.238V64.352l9.484,9.4Zm1.392,1.392,9.49-9.49,3.325,3.3a.985.985,0,0,0,1.389,0l3.242-3.242,9.438,9.438Zm28.277-1.392L22.2,73.8l9.438-9.438Z",
    transform: "translate(0 -61)",
    fill: "#263a4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactmessage);
export default __webpack_public_path__ + "static/media/contactmessage.780e400114b16352d5c7dbc370f8f5a3.svg";
export { ForwardRef as ReactComponent };